export function hasInitialValueExpression(fieldName: string, dataSource = 'initialData'): string {
  return `${dataSource}?.${fieldName} !== undefined && ${dataSource}?.${fieldName} !== null && ${dataSource}?.${fieldName} !== ''`
}
